module.exports = __webpack_public_path__ + "img/icon-ar-view.f32901b3.svg";